import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function WarehouseSectionSelectModal({ title, onClose, upperWarehouseId, handleWarehouseSectionClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    section_name: true,
    warehouse_id: false,
    warehouse_name: true,
    workplace_id: false,
    section_name: true,
    section_width: true,
    section_depth: true,
    section_height: true,
    memo: true,
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      section_name: true,
      warehouse_id: false,
      warehouse_name: true,
      workplace_id: false,
      section_name: true,
      section_width: true,
      section_depth: true,
      section_height: true,
      memo: true,
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'section_id', width: 0, headerAlign: 'center' },
        { field: 'section_name', headerName: '구역명', width: 130, headerAlign: 'center', align:'left' },
        { field: 'workplace_id', headerName: 'workplace_id', width: 0, headerAlign: 'center' },
        { field: 'workplace_name', headerName: '사업장명', width: 120, headerAlign: 'center', align:'left' },
        { field: 'warehouse_id', headerName: 'warehouse_id', width: 0, headerAlign: 'center' },
        { field: 'warehouse_name', headerName: '창고명', width: 120, headerAlign: 'center', align:'left' },
        { field: 'section_width', headerName: '구역가로', width: 90, headerAlign: 'center', align:'right' },
        { field: 'section_depth', headerName: '구역세로', width: 90, headerAlign: 'center', align:'right' },
        { field: 'section_height', headerName: '구역높이', width: 90, headerAlign: 'center', align:'right' },
        { field: 'memo', headerName: '비고', width: 120, headerAlign: 'center', align:'left' }
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/WarehouseSectionList',
        {
        params : {
          keyword: keyword,
          upperWarehouseId: upperWarehouseId
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        
        var array = response.data.map((item, index) => ({
            id: item.section_id,
            section_name: item.section_name,
            workplace_id: item.workplace_id,
            workplace_name: item.workplace_name,
            warehouse_id: item.warehouse_id,
            warehouse_name: item.warehouse_name,
            section_width: item.section_width,
            section_depth: item.section_depth,
            section_height: item.section_height,
            memo: item.memo
        }));
        setRows(array);
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handleWarehouseSectionClick 이벤트 만들어 놓아야함.
    handleWarehouseSectionClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleWarehouseSectionClick({
      id: '',
      section_name: '',
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default WarehouseSectionSelectModal;